import apiClient from '../services/apiClient';

export default {
	namespaced: true,
	state: {
		access_token: '',
		retailer: null,
	},
	getters: {
		retailer(state) {
			return state.retailer;
		},
	},
	mutations: {
		ACCESS_TOKEN(state, accessToken) {
			state.access_token = accessToken
		},
		SET_RETAILER(state, retailer) {
			state.retailer = retailer
		},
		CLEAR_STORE(state) {
			state.access_token = '';
			state.retailer = null;
		}
	},
	actions: {
		async getRetailers({commit}) {
			await apiClient.get('settings/retailer/get').then(res => {
				commit('SET_RETAILER', res.data);
			}).catch(err => {
				console.log(err)
			})
		},
		async createRetailers({commit}, retailerSubmit) {
			apiClient.post('settings/retailer/create', retailerSubmit).then(res => {
				commit('SET_RETAILER', res.data);
			}).catch(err => {
				console.log(err)
			})
		},
		updateRetailers({commit}, retailerUpdate) {
			return new Promise((resolve, reject) => {
				apiClient.put('settings/retailer/update', retailerUpdate).then(res => {
					commit('SET_RETAILER', res.data);
					resolve();
				}).catch(err => {
					reject(err);
				})
			});
		},
		async clear({commit}) {
			commit('CLEAR_STORE');
		}
	}
}
